import * as React from 'react';

import * as styles from './PublishTermsError.css';
const sadSmileIcon = require('../../../../assets/sad-smile.png');

export const PublishTermsError = () => {
  return (
    <div className={styles['wrapper']}>
      <img src={sadSmileIcon} width={24} height={24} className={styles['icon']} />
      <span className={styles['message']}>Что-то пошло не так. Повторите попытку позже.</span>
    </div>
  );
};
